import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getCharacterRelationships, type CharacterRelationshipsResponse } from '../api/characterRelationships';

export const useCharacterRelationships = (bookId?: number, options: { enabled?: boolean; isSpoil?: boolean } = {}) => {
  const isSpoil = options.isSpoil ?? false;
  return useQuery<CharacterRelationshipsResponse, Error>({
    queryKey: ['character-relationships', bookId, isSpoil],
    queryFn: () => getCharacterRelationships(bookId as number, isSpoil),
    enabled: !!bookId && options.enabled !== false,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
